export enum UserRole {
  COMPANY = 'company',
  CUSTOMER = 'customer',
  STAFF = 'staff',
}
